<template>
  <layout-default>

    <router-view />

  </layout-default>

</template> 
 
<script>
import LayoutDefault from '@core/layouts/layout-default/LayoutDefault.vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    LayoutDefault,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
